import { cn } from "@/lib/utils";

interface SkeletonProps {
  className?: string;
}

const SkeletonPulse = ({ className }: SkeletonProps) => (
  <div 
    className={cn(
      "bg-gradient-to-r from-muted via-muted/40 to-muted bg-[length:250%_100%] animate-shimmer rounded",
      className
    )}
  />
);

interface BlogCardSkeletonProps {
  index?: number;
}

const BlogCardSkeleton = ({ index = 0 }: BlogCardSkeletonProps) => {
  return (
    <div
      className="bg-card rounded-xl overflow-hidden border border-border shadow-sm animate-fade-in-up"
      style={{ animationDelay: `${index * 0.08}s` }}
    >
      <div className="relative aspect-[16/10] overflow-hidden">
        <SkeletonPulse className="h-full w-full rounded-none" />
        <div className="absolute top-3 left-3">
          <SkeletonPulse className="h-5 w-20 rounded-full" />
        </div>
      </div>

      <div className="p-4 space-y-3">
        <div className="space-y-2">
          <SkeletonPulse className="h-5 w-full" />
          <SkeletonPulse className="h-5 w-3/4" />
        </div>
        <div className="space-y-2">
          <SkeletonPulse className="h-4 w-full" />
          <SkeletonPulse className="h-4 w-5/6" />
        </div>
        <div className="flex items-center justify-between pt-2">
          <SkeletonPulse className="h-3 w-20" />
          <SkeletonPulse className="h-3 w-16" />
        </div>
      </div>
    </div>
  );
};

export default BlogCardSkeleton;
